import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-daily-fact-status-badge',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './daily-fact-status-badge.component.html',
  styleUrl: './daily-fact-status-badge.component.scss',
})
export class DailyFactStatusBadgeComponent {
  /** Video status: PENDING, SUCCESS, FAILED, or null/undefined */
  status = input<string | null | undefined>();
  /** Translated label for display (when not pending) */
  label = input<string>('');
  /** CSS class suffix: none, pending, success, failed */
  statusClass = input<string>('none');
}
